// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#dataview-modal___BV_modal_body_ .avatar-banner {\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n", ""]);
// Exports
module.exports = exports;
